import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 9.6,
			fill: "url(#paint0_linear_5101_24137)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1116 15.5112L7.34766 21.2254H13.1656V26.9397H18.9819L18.9739 32.654L24.7966 26.9397V21.2254L30.613 15.5112V9.79688H24.803L18.9787 15.5112H13.1116Z",
			stroke: "url(#paint1_linear_5101_24137)",
			strokeOpacity: .15,
			strokeWidth: 1.63265
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_5101_24137",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 7,
			y: 9,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M13.162 15.5112L7.34766 21.2254H13.164V26.9397H18.9803V32.654L24.7982 26.9397V21.2254L30.613 15.5112V9.79688H24.7998L18.9803 15.5112H13.162Z",
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_5101_24137)",
			children: /* @__PURE__ */ _jsxs("g", {
				filter: "url(#filter0_i_5101_24137)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M13.162 15.5112L7.34766 21.2254H13.164V26.9397H18.9803V32.654L24.7982 26.9397V21.2254L30.613 15.5112V9.79688H24.7998L18.9803 15.5112H13.162Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M24.7988 9.79688H30.6131V15.5118H24.7988V9.79688Z",
						fill: "#ECECEC"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M18.9824 15.5156H24.7992V21.2281H18.9824V15.5156Z",
						fill: "#C7C7C7"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M13.1641 15.5156H18.9809V21.2281H13.1641V15.5156Z",
						fill: "#A3A3A3"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M12.8379 21.2246H24.9823V26.9396H12.8379V21.2246Z",
						fill: "#787878"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M30.6131 15.5117H24.7988V21.2242L30.6131 15.5117Z",
						fill: "#A8A8A8"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M24.7985 26.9395H18.4492V33.1776L24.7985 26.9395Z",
						fill: "#838383"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M18.9824 15.5118H24.7992V9.79688L18.9824 15.5118Z",
						fill: "#B7B7B7"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M7.34766 21.2242H13.1645V15.5117L7.34766 21.2242Z",
						fill: "#909090"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M18.9824 21.2246H24.7992V26.9396H18.9824V21.2246Z",
						fill: "#8A8A8A"
					})
				]
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 39,
			height: 39,
			rx: 9.1,
			stroke: "white",
			strokeOpacity: .1
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_i_5101_24137",
				x: 7.34766,
				y: 9.79688,
				width: 23.2654,
				height: 25.0134,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1.63265 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3.06122 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "shape",
						result: "effect1_innerShadow_5101_24137"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_5101_24137",
				x1: 20,
				y1: 40,
				x2: 20,
				y2: -1.39887e-7,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#111111" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#1D1D1D"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_5101_24137",
				x1: 29.1684,
				y1: 11.0214,
				x2: 10.7964,
				y2: 28.9354,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "white",
					stopOpacity: .57
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
